import { render, staticRenderFns } from "./PassengersListModal.vue?vue&type=template&id=384fe0be&"
import script from "./PassengersListModal.vue?vue&type=script&lang=js&"
export * from "./PassengersListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384fe0be')) {
      api.createRecord('384fe0be', component.options)
    } else {
      api.reload('384fe0be', component.options)
    }
    module.hot.accept("./PassengersListModal.vue?vue&type=template&id=384fe0be&", function () {
      api.rerender('384fe0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/transports/Modals/PassengersListModal.vue"
export default component.exports